<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="model.CustomerName"
        :secondaryLabel="model.CustomerCode"
        recordType="Customer"
        v-if="model.CustomerCode"
      />
    </template>
    <div class="css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  ref="contactGrid"
                  :columns="columns"
                  :height="gridHeight - 20"
                  @selection-changed="onSelectionChanged"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  @content-ready="addGridNoResults($event)"
                  v-if="model.CustomerCode"
                  :selection="{ mode: 'single' }"
                  @exporting="
                    onGridToExcelExporting(
                      $event,
                      `Customer - ${baseView.id} - Contacts`,
                      columns
                    )
                  "
                >
                  <DxPaging :page-size="50" :enabled="false" />
                  <DxPager
                    :showInfo="true"
                    :showPageSizeSelector="false"
                    :infoText="'({2} items)'"
                    :visible="false"
                  />

                  <DxScrolling
                    :mode="'virtual'"
                    :row-rendering-mode="'virtual'"
                    :preloadEnabled="true"
                  />
                  <DxExport :enabled="true" />
                  <template #active-cell-template="{ data }">
                    <GcInactive :inactive="data.data.Inactive" />
                  </template>
                  <template #email-invoice-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.EmailInvoice == 'Y'"
                      :read-only="true"
                    />
                  </template>
                  <template #email-credit-note-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.EmailCreditNote == 'Y'"
                      :read-only="true"
                    />
                  </template>

                  <template #email-sales-order-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.EmailSalesOrder == 'Y'"
                      :read-only="true"
                    />
                  </template>
                  <template #email-delivery-note-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.EmailDeliveryNote == 'Y'"
                      :read-only="true"
                    />
                  </template>

                  <template #email-customer-statement-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.EmailCustomerStatement == 'Y'"
                      :read-only="true"
                    />
                  </template>
                  <template #email-receipt-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.EmailReceipt == 'Y'"
                      :read-only="true"
                    />
                  </template>
                  <template #email-rrp-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.EmailRRP == 'Y'"
                      :read-only="true"
                    />
                  </template>

                  <template #name-cell-template="{ data }">
                    <span
                      >{{ data.data.FirstName }} {{ data.data.Surname }}</span
                    >
                  </template>
                </dx-data-grid>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                  :initial-filter="initialFilter"
                  v-if="model.CustomerCode"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="never">
              <div class="toolbar-label">
                <span class="text-primary"
                  >{{ model.FirstName }} {{ model.Surname }}</span
                >
              </div>
            </DxItem>

            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: formsConfig.validationGroup,
                labelLocation: 'left',
              }"
              locate-in-menu="after"
              :disabled="baseView.mode == 'review' ? true : false"
            ></DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <!-- <DxItem
              :options="toolbar.delete"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            /> -->

            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible="formsConfig.editableOption"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form>
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="'customer-contact-form'"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
                @content-ready="onFormContentReady"
                :ref="'customer-contact-form'"
              ></DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CustomerContactService } from "../../_services/api/customers/customer-contact.service";
import { CustomerContactTransactionDistributionService } from "../../_services/api/customers/customer-contact.service";

import BaseViewMixin from "../../v1/_mixins/base.view";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import validationEngine from "devextreme/ui/validation_engine";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { FeatureStorage } from "../../_services/storage";

export default {
  components: {},
  mixins: [BaseViewMixin, CustomerTabsMixin],
  created() {
    this.selectedIndex = 2;
  },
  updated() {
    if (this.showRightContainer) validationEngine.validateGroup("formsData");
  },
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",
          onClick: this.close,
          tabIndex: -1,
        },
        edit: {
          icon: "edit",
          tabIndex: -1,
          onClick: () => {
            this.$router.push({
              path: `/customer-contact/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          tabIndex: -1,
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveCustomerContact(e);
          },
        },
        delete: {
          icon: "trash",
          tabIndex: -1,
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickDelete();
            this.deleteCustomerContact(e);
          },
        },
        audit: {
          icon: "clock",
          tabIndex: -1,
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      advanceFilterModel: {
        Inactive: "",
        EmailCreditNote: "",
        EmailCustomerStatement: "",
        EmailDeliveryNote: "",
        EmailInvoice: "",
        EmailReceipt: "",
        EmailRRP: "",
        EmailSalesOrder: "",
      },
      model: {
        CustomerCode: "",
        CustomerName: "",
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        RecordId: "00000000-0000-0000-0000-000000000000",
        LineNo: 0,
        FirstName: "",
        Surname: "",
        Department: "",
        Position: "",
        Email: "",
        Phone: "",
        Mobile: "",
        Fax: "",
        EmailInvoice: false,
        EmailCreditNote: false,
        EmailSalesOrder: false,
        EmailDeliveryNote: false,
        EmailCustomerStatement: false,
        EmailReceipt: false,
        EmailRRP: false,
        Active: true,
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
        PhysicalAddressState: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressCountry: "",
      },

      HeaderKey: 1,
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Contacts",
          message: "Get Started, Add a Contact",
        },
      },
      FocusOnPhone: false,
    };
  },
  computed: {
    initialFilter() {
      return [["CustomerCode", "=", this.model.CustomerCode]];
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "EmailInvoice",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Email Invoice",
              editorOptions: {
                items: [
                  {
                    text: "Yes",
                    value: "Y",
                  },
                  {
                    text: "No",
                    value: "N",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
            {
              dataField: "EmailCreditNote",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Email Credit Note",
              editorOptions: {
                items: [
                  {
                    text: "Yes",
                    value: "Y",
                  },
                  {
                    text: "No",
                    value: "N",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
            {
              dataField: "EmailSalesOrder",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Email Sales Order",
              editorOptions: {
                items: [
                  {
                    text: "Yes",
                    value: "Y",
                  },
                  {
                    text: "No",
                    value: "N",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
            {
              dataField: "EmailDeliveryNote",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Email Delivery Note",
              editorOptions: {
                items: [
                  {
                    text: "Yes",
                    value: "Y",
                  },
                  {
                    text: "No",
                    value: "N",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
            {
              dataField: "EmailCustomerStatement",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Email Customer Statement",
              editorOptions: {
                items: [
                  {
                    text: "Yes",
                    value: "Y",
                  },
                  {
                    text: "No",
                    value: "N",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
            {
              dataField: "EmailReceipt",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Email Receipt",
              editorOptions: {
                items: [
                  {
                    text: "Yes",
                    value: "Y",
                  },
                  {
                    text: "No",
                    value: "N",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
            {
              dataField: "EmailRRP",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Email RRP",
              editorOptions: {
                items: [
                  {
                    text: "Yes",
                    value: "Y",
                  },
                  {
                    text: "No",
                    value: "N",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
            {
              dataField: "Inactive",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Status",
              editorOptions: {
                items: [
                  {
                    text: "Active",
                    value: "N",
                  },
                  {
                    text: "Inactive",
                    value: "Y",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
          ]),
        },
      ];
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Name",
          dataField: "FirstName",
          cellTemplate: "name-cell-template",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          gcExport: ["FirstName", "Surname"],
        },
        {
          gcLabel: "Department",
          dataField: "Department",
          gcType: "String",
          width: 220,
          maxWidth: 220,
        },
        {
          gcLabel: "Position",
          dataField: "Position",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 120,
          maxWidth: 120,
        },
        {
          gcLabel: "Phone",
          dataField: "Phone",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: ColumnWidth.MobileNumber.width,
          maxWidth: ColumnWidth.MobileNumber.minWidth,
        },
        {
          gcLabel: "Mobile",
          dataField: "Mobile",
          gcType: "String",
          width: ColumnWidth.MobileNumber.width,
          maxWidth: ColumnWidth.MobileNumber.minWidth,
        },

        {
          gcLabel: "Email",
          dataField: "Email",
          gcType: "String",
          width: ColumnWidth.Email.width,
          maxWidth: ColumnWidth.Email.minWidth,
        },

        {
          dataField: "EmailInvoice",
          gcLabel: "Email Invoice",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 100,
          maxWidth: 100,
          cellTemplate: "email-invoice-cell-template",
        },

        {
          dataField: "EmailCreditNote",
          gcLabel: "Email Credit Note",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 100,
          maxWidth: 100,
          cellTemplate: "email-credit-note-cell-template",
        },

        {
          dataField: "EmailSalesOrder",
          gcLabel: "Email Sales Order",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 100,
          maxWidth: 100,
          cellTemplate: "email-sales-order-cell-template",
        },
        {
          dataField: "EmailDeliveryNote",
          gcLabel: "Email Delivery Note",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 100,
          maxWidth: 100,
          cellTemplate: "email-delivery-note-cell-template",
        },
        {
          dataField: "EmailCustomerStatement",
          gcLabel: "Email Customer Statement",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 100,
          maxWidth: 100,
          cellTemplate: "email-customer-statement-cell-template",
        },
        {
          dataField: "EmailReceipt",
          gcLabel: "Email Receipt",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 100,
          maxWidth: 100,
          cellTemplate: "email-receipt-cell-template",
        },

        {
          dataField: "EmailRRP",
          gcLabel: "Email RRP",
          gcType: "String",
          gcSubType: "HiddenDescription",
          width: 100,
          maxWidth: 100,
          cellTemplate: "email-rrp-cell-template",
        },

        {
          gcType: "String",
          gcSubType: "Chip",
          dataField: "Inactive",
          cellTemplate: "active-cell-template",
        },
        {
          gcLabel: "First Name",
          dataField: "FirstName",
          width: 120,
          maxWidth: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Surname",
          dataField: "Surname",
          width: 120,
          maxWidth: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
      ]);
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "FirstName",
              gcLabel: "First Name",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
                tabIndex: 1,
              },
              required: true,
            },
            {
              dataField: "Surname",
              gcLabel: "Surname",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
                tabIndex: 2,
              },
              required: true,
            },
            {
              dataField: "Department",
              gcLabel: "Department",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 3,
              },
            },

            {
              dataField: "Position",
              gcLabel: "Position",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 4,
              },
            },

            {
              dataField: "Email",
              gcLabel: "Email",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 200,
                tabIndex: 5,
                onKeyDown: (e) => {
                  if (e.event.keyCode == 9 && !e.event.shiftKey) {
                    this.setNextFocusOnPhone(true);
                  }
                },
              },
              validationRules: [
                {
                  type: "custom",
                  message:
                    "Email is required when 1 or more email options is On",
                  validationCallback: this.emailValidator,
                  reevaluate: true,
                },
              ],
            },

            {
              dataField: "Phone",
              gcLabel: "Phone",
              gcType: "String",
              editorType: "dxTextBox",
              cssClass: "Phone-1",
              editorOptions: {
                maxLength: 20,
                tabIndex: 6,
                cssClass: "Phone-2",
                onFocusIn: () => {
                  this.setNextFocusOnPhone(false);
                  document
                    .querySelector(".Phone-1 .dx-texteditor-input")
                    .select();
                },
              },
            },

            {
              dataField: "Mobile",
              gcLabel: "Mobile",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 20,
                tabIndex: 7,
              },
            },

            {
              dataField: "PhysicalAddressStreetLine1",
              gcLabel: "Street Line 1",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
                tabIndex: 8,
              },
            },
            {
              dataField: "PhysicalAddressStreetLine2",
              gcLabel: "Street Line 2",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
                tabIndex: 9,
              },
            },
            {
              dataField: "PhysicalAddressSuburb",
              gcLabel: "Suburb",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
                tabIndex: 10,
              },
            },

            {
              dataField: "PhysicalAddressState",
              gcLabel: "State",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                tabIndex: 11,
              },
            },

            {
              dataField: "PhysicalAddressPostcode",
              gcLabel: "Post Code",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 20,
                tabIndex: 12,
              },
            },

            {
              dataField: "PhysicalAddressCountry",
              gcLabel: "Country",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 50,
                tabIndex: 13,
              },
            },
          ]),
        },

        {
          itemType: "group",
          caption: "Email Options",
          colCount: 2,
          items: this.parseFormColumns([
            {
              dataField: "EmailInvoice",
              gcLabel: "Invoice",
              gcType: "Boolean",
              editorOptions: {
                readOnly: !this.model.Email,
                tabIndex: 14,
              },
            },

            {
              dataField: "EmailCreditNote",
              gcLabel: "Credit Note",
              gcType: "Boolean",
              editorOptions: {
                readOnly: !this.model.Email,
                tabIndex: 15,
              },
            },
            {
              dataField: "EmailSalesOrder",
              gcLabel: "Sales Order",
              gcType: "Boolean",
              editorOptions: {
                readOnly: !this.model.Email,
                tabIndex: 16,
              },
            },
            {
              dataField: "EmailDeliveryNote",
              gcLabel: "Delivery Note",
              gcType: "Boolean",
              editorOptions: {
                readOnly: !this.model.Email,
                tabIndex: 17,
              },
            },
            {
              dataField: "EmailCustomerStatement",
              gcLabel: "Customer Statement",
              gcType: "Boolean",
              editorOptions: {
                readOnly: !this.model.Email,
                tabIndex: 18,
              },
            },
            {
              dataField: "EmailReceipt",
              gcLabel: "Receipt",
              gcType: "Boolean",
              editorOptions: {
                readOnly: !this.model.Email,
                tabIndex: 19,
              },
            },
            {
              dataField: "EmailRRP",
              gcLabel: "RRP",
              gcType: "Boolean",
              editorOptions: {
                readOnly: !this.model.Email,
                tabIndex: 20,
              },
            },
          ]),
        },
      ];

      return formFields;
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Active",
          gcType: "Boolean",
          gcLabel: "Active",
        },
      ]);
    },
    dataSourceConfig() {
      return CustomerContactService.dataSourceConfig(
        "api/CustomerContactList",
        {
          select: [
            "CustomerCode,RecordId,LineNo,FirstName,Surname,Department,Position,Phone,Mobile,Email,Inactive,EmailCreditNote,EmailCustomerStatement,EmailDeliveryNote,EmailInvoice,EmailReceipt,EmailSalesOrder,EmailRRP",
          ],
          // sort: [{ selector: "FirstName", desc: false }],
          filter: [["CustomerCode", "=", this.model.CustomerCode]],
        }
      );
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      // validationEngine.validateGroup("formsData");
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    showFilterRightContainer() {
      setTimeout(() => {
        let grid = this.$refs["contactGrid"].instance;
        grid.updateDimensions();
      }, 10);
    },
    showRightContainer() {
      setTimeout(() => {
        let grid = this.$refs["contactGrid"].instance;
        grid.updateDimensions();
      }, 10);
    },
  },
  methods: {
    setNextFocusOnPhone(set) {
      this.FocusOnPhone = set;
    },
    onFormContentReady(e) {
      if (e) {
        validationEngine.validateGroup("customer-contact-form");
        setTimeout(() => {
          if (this.FocusOnPhone) {
            e.component.instance().getEditor("Phone").focus();
          } else e.component.instance().getEditor("FirstName").focus();
        }, 100);
      }
    },
    emailValidator(options) {
      return !(
        options.value == "" &&
        (this.model.EmailInvoice ||
          this.model.EmailCreditNote ||
          this.model.EmailSalesOrder ||
          this.model.EmailDeliveryNote ||
          this.model.EmailCustomerStatement ||
          this.model.EmailReceipt ||
          this.model.EmailRRP)
      );
    },
    emailSwitchValidator(options) {
      if (!options.value) {
        return true;
      } else {
        return this.model.Email != "";
      }
    },
    async close() {
      if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["contactGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.CustomerCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-contact/${this.baseView.id}`,
          });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["contactGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.CustomerCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router.push({
          path: `/customer-contact/${this.baseView.id}`,
        });
      }
    },
    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      if (this.baseView.query && this.baseView.query.from) {
        this.$router.push({
          path: this.baseView.query.from,
        });
      } else
        this.$router.push({
          path: "/customer",
        });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      exportButton.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            visible: FeatureStorage.checkPermission(
              "CustomerContact",
              "create"
            ),
            onClick: async () => {
              this.$logger.trackEventButtonClickAddNew();
              if (this.baseView.mode == "edit") {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to leave?",
                  "Unsaved changes"
                );

                if (confirmLeaving) {
                  this.setIgnoreRouteChangeConfirmation();
                  this.createNewContact();
                }
              } else {
                this.createNewContact();
              }
            },
          },
        },
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    createNewContact() {
      this.model.RecordId = "00000000-0000-0000-0000-000000000000";
      this.model.DateChanged = "";
      this.model.DateCreated = "";
      this.model.ChangedBy = "";
      this.model.CreatedBy = "";
      this.model.LineNo = 0;
      this.model.FirstName = "";
      this.model.Surname = "";
      this.model.Department = "";
      this.model.Position = "";
      this.model.Email = "";
      this.model.Phone = "";
      this.model.Mobile = "";
      this.model.Fax = "";
      this.model.EmailInvoice = false;
      this.model.EmailCreditNote = false;
      this.model.EmailSalesOrder = false;
      this.model.EmailDeliveryNote = false;
      this.model.EmailCustomerStatement = false;
      this.model.EmailReceipt = false;
      this.model.EmailRRP = false;
      this.model.Active = true;
      this.model.PhysicalAddressStreetLine1 = "";
      this.model.PhysicalAddressStreetLine2 = "";
      this.model.PhysicalAddressSuburb = "";
      this.model.PhysicalAddressState = "";
      this.model.PhysicalAddressPostcode = "";
      this.model.PhysicalAddressCountry = "";
      this.baseView.id = this.model.CustomerCode;

      this.$router.push({
        path: `/customer-contact/create/${this.baseView.id}`,
      });
    },
    handleLocalRouteChange() {
      let that = this;
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        this.showLoading(true);
        this.model.RecordId = this.baseView.id;
        this.getRecord().then((response) => {
          if (response.data.value.length > 0) {
            this.model.RecordId = response.data.value[0].RecordId;
            this.model.DateChanged = response.data.value[0].DateChanged;
            this.model.DateCreated = response.data.value[0].DateCreated;
            this.model.ChangedBy = response.data.value[0].ChangedBy;
            this.model.CreatedBy = response.data.value[0].CreatedBy;
            this.model.LineNo = response.data.value[0].LineNo;
            this.model.CustomerCode = response.data.value[0].CustomerCode;
            this.model.CustomerName = response.data.value[0].Customer.Name;
            this.model.FirstName = response.data.value[0].FirstName;
            this.model.Surname = response.data.value[0].Surname;
            this.model.Department = response.data.value[0].Department;
            this.model.Position = response.data.value[0].Position;
            this.model.Email = response.data.value[0].Email;
            this.model.Phone = response.data.value[0].Phone;
            this.model.Mobile = response.data.value[0].Mobile;
            this.model.Fax = response.data.value[0].Fax;
            this.model.Active = response.data.value[0].Inactive == "N";

            this.model.PhysicalAddressStreetLine1 =
              response.data.value[0].PhysicalAddressStreetLine1;
            this.model.PhysicalAddressStreetLine2 =
              response.data.value[0].PhysicalAddressStreetLine2;
            this.model.PhysicalAddressSuburb =
              response.data.value[0].PhysicalAddressSuburb;
            this.model.PhysicalAddressState =
              response.data.value[0].PhysicalAddressState;
            this.model.PhysicalAddressPostcode =
              response.data.value[0].PhysicalAddressPostcode;
            this.model.PhysicalAddressCountry =
              response.data.value[0].PhysicalAddressCountry;

            CustomerContactTransactionDistributionService.getByCustomerCodeLineNo(
              this.model.CustomerCode,
              this.model.LineNo
            ).then((response2) => {
              if (response2.data.value.length > 0) {
                this.model.EmailInvoice =
                  response2.data.value.find(
                    (element) => element.TransactionCode == "INV"
                  ) != null;
                this.model.EmailCreditNote =
                  response2.data.value.find(
                    (element) => element.TransactionCode == "CREDIT"
                  ) != null;
                this.model.EmailSalesOrder =
                  response2.data.value.find(
                    (element) => element.TransactionCode == "ISO"
                  ) != null;
                this.model.EmailDeliveryNote =
                  response2.data.value.find(
                    (element) => element.TransactionCode == "DELIV"
                  ) != null;
                this.model.EmailCustomerStatement =
                  response2.data.value.find(
                    (element) => element.TransactionCode == "STMNT"
                  ) != null;
                this.model.EmailReceipt =
                  response2.data.value.find(
                    (element) => element.TransactionCode == "CREC"
                  ) != null;
                this.model.EmailRRP =
                  response2.data.value.find(
                    (element) => element.TransactionCode == "RRPMail"
                  ) != null;
              } else {
                this.model.EmailInvoice = false;
                this.model.EmailCreditNote = false;
                this.model.EmailSalesOrder = false;
                this.model.EmailDeliveryNote = false;
                this.model.EmailCustomerStatement = false;
                this.model.EmailReceipt = false;
                this.model.EmailRRP = false;
              }
            });

            // that.refreshView();
          }
          this.showLoading(false);
        });
      } else {
        if (!this.model.CustomerCode) {
          CustomerService.getByCode(that.baseView.id).then((response) => {
            if (response.data.value.length > 0) {
              that.model.CustomerCode = response.data.value[0].Code;
              that.model.CustomerName = response.data.value[0].Name;
              // that.refreshView();
            }
          });
        }
      }
    },
    async getRecord() {
      return CustomerContactService.getByRecordId(this.baseView.id);
    },
    onSelectionChanged({ selectedRowsData }) {
      if (
        selectedRowsData.length == 0 ||
        this.baseView.id == selectedRowsData[0].RecordId
      ) {
        return;
      }

      this.baseView.id = selectedRowsData[0].RecordId;
      this.$router.push({
        path: `/customer-contact/review/${selectedRowsData[0].RecordId}`,
      });
      this.baseView.tempId = this.model.CustomerCode;
    },

    async deleteCustomerContact() {
      let that = this;

      let confirmLeaving = await this.$confirm(
        `Are you sure you want to delete ${this.model.FirstName}?`,
        "Delete Contact"
      );

      if (confirmLeaving) {
        this.showLoading(true);
        await CustomerContactService.delete({
          RecordId: this.model.RecordId,
        })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            that.showLoading(false);
            that.close();
            let grid = this.$refs["contactGrid"].instance;
            grid.refresh();
          })
          .catch((error) => {
            this.displayServerError(error, "Customer Contact delete failed");
          });
      }
    },
    async saveCustomerContact() {
      // const result = await e.validationGroup.validate();

      const mainForm = await validationEngine.validateGroup(
        "customer-contact-form"
      );

      if (!mainForm.isValid) {
        this.addErrorMessagesFromValidationResult(mainForm);
        this.displayValidationSummary();
        return;
      }
      this.showLoading(true);
      await CustomerContactService.save(this.baseView.mode, {
        CustomerCode: this.model.CustomerCode,
        Inactive: this.model.Active ? "N" : "Y",
        RecordId: this.model.RecordId,
        LineNo: this.model.LineNo,
        FirstName: this.model.FirstName,
        Surname: this.model.Surname,
        Department: this.model.Department,
        Position: this.model.Position,
        Email: this.model.Email,
        Phone: this.model.Phone,
        Mobile: this.model.Mobile,
        Fax: this.model.Fax,
        EmailInvoice: this.model.EmailInvoice ? "Y" : "N",
        EmailCreditNote: this.model.EmailCreditNote ? "Y" : "N",
        EmailSalesOrder: this.model.EmailSalesOrder ? "Y" : "N",
        EmailDeliveryNote: this.model.EmailDeliveryNote ? "Y" : "N",
        EmailCustomerStatement: this.model.EmailCustomerStatement ? "Y" : "N",
        EmailReceipt: this.model.EmailReceipt ? "Y" : "N",
        EmailRRP: this.model.EmailRRP ? "Y" : "N",
        PhysicalAddressStreetLine1: this.model.PhysicalAddressStreetLine1,
        PhysicalAddressStreetLine2: this.model.PhysicalAddressStreetLine2,
        PhysicalAddressSuburb: this.model.PhysicalAddressSuburb,
        PhysicalAddressState: this.model.PhysicalAddressState,
        PhysicalAddressPostcode: this.model.PhysicalAddressPostcode,
        PhysicalAddressCountry: this.model.PhysicalAddressCountry,
      })
        .then((res) => {
          if (this.baseView.mode == "create") {
            this.model.RecordId = res.data.RecordId;
            this.model.LineNo = res.data.LineNo;
          }

          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveCustomerContact", res);
          this.$notify(
            `Customer Contact ${this.model.FirstName} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-contact/review/${this.model.RecordId}`,
          });
          this.baseView.tempId = this.model.CustomerCode;
        })
        .catch((error) => {
          this.displayServerError(error, "Customer Contact saved failed");
        });
    },
  },
};
</script>
